<template>
  <div style="width: 1200px;margin:0 auto;">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      text-color="#000000"
      active-text-color="#000000"
    >
      <el-menu-item>
       <a @click="toHome()">
          <img src="/pc/static/img/hom/logo.png" />
        </a>
      </el-menu-item>
      <!-- <el-menu-item>
        <a
          href="http://www.gaminglabs.com/extranetgli/cmsadmin/getsplash.asp?i=277"
          target="_blank"
        >
          <img style="width: 47px;" src="/pc/static/img/home/icon_01.jpg" />
        </a>
      </el-menu-item> -->

      <!-- <el-menu-item class="el-menu-item-margin contact-us" style="text-align:left;padding: 0px 20px;">
        <a :class="{ active: activeIndex === '/about' }" style="text-align:left;" href="/about">ABOUT US</a>
      </el-menu-item>
      <el-menu-item class="el-menu-item-margin contact-us" style="text-align:left;padding: 0px 20px;">
        <a :class="{ active: activeIndex === '/disclaimer' }" style="text-align:left;" href="/disclaimer">DISCLAIMER</a>
      </el-menu-item> -->
      <el-menu-item class="el-menu-item-margin contact-us" style="text-align:left;padding: 0px 20px;">
        <a :class="{ active: activeIndex === '/shop' }" style="text-align:left;" href="/shop">SHOP</a>
      </el-menu-item>
      <el-menu-item class="el-menu-item-margin contact-us" style="text-align:left;padding: 0px 20px;">
        <a :class="{ active: activeIndex === '/home' }" style="text-align:left;" href="/home">HOME</a>
      </el-menu-item>

      <!-- <el-menu-item class="contact-us">
        <a style="line-height: 90px;" target="_blank" href="/pc/about">{{ $t('home.p6') }}</a>
      </el-menu-item> -->
     <!-- <li class="lang">
        <lang-select></lang-select>
      </li> -->
    </el-menu>
  </div>
</template>

<script>
// @ is an alias to /src
// import LangSelect from './LangSelect.vue'

export default {
  data () {
    return {
      popover: false,
      popoverStyle: {

      },
      tabs: []
    }
  },
  components: {
    // LangSelect
  },
  computed: {
    activeIndex () {
      return this.$store.state.tab
    }
  },
  methods: {
    toHome () {
      window.location.href = '/home'
    }
  }
}
</script>

<style lang="scss">
.el-popover.el-popper {
  background: rgba(0, 0, 0, 0.6);
  border: none;
  margin-top: 3px!important;
  padding: 0px;
  width: 100%!important;
  min-width: 1200px!important;
  left: 0px!important;
  .popular-content {
    position: relative;
    width: 600px;
    top: 0px;
    left:20px;
    // text-align: center;
    font-size: 18px;
    font-weight: 100;
    padding: 10px 0px 16px 0px;
    div {
      vertical-align: top;
      text-align: center;
    }
    a {
      color: #e7e7e7;
      display: block;
      line-height: 32px;
      cursor: pointer;
      &:hover {
        color: #3e6aff;
      }
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-menu-demo {
  position: relative;
  background-color: rgba(255, 255, 255, 255);
  a {
    cursor: pointer;
  }
  .logo {
    position: absolute;
    width: 160px;
    height: 38px;
    left: 50%;
    top: 50%;
    margin-left: -80px;
    margin-top: -19px;
    &:focus {
      outline: none;
    }
    img {
      width: 100%;
      border-style: none;
    }
  }
}
.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    background-color: inherit!important;
  }
.el-menu.el-menu--horizontal {
  border-bottom: none;
  .el-menu-item {
    height: 62px;
    line-height: 62px;
    font-size: 18px;
    font-weight: 100;
    color: #d2d2d2;
    padding: 0 10px;
    border-bottom: none;
    display: inline-block;
    a {
      display: block;
    }
    a.active {
      color: #f5b601!important;
    }
    &:hover {
      a {
        color: #f5b601!important;
      }
    }
  }
  .el-menu-item-margin {
    padding: 0 35px;
  }
  .contact-us {
    float: right;
    // font-size: 18px;
    // font-weight: 100;
    // padding: 0 10px;
    // height: 87px;
    // line-height: 87px;
  }
  .el-dropdown-link {
    cursor: pointer;
    font-size: 18px;
    font-weight: 100;
    color: #d2d2d2;
  }
  .lang {
    float: right;
    height: 88px;
    line-height: 90px;
    padding: 0 10px;
    cursor: pointer;
    list-style: none;
    border-bottom: 2px solid transparent;
    &:focus {
      outline: none;
    }
  }
}
</style>
